const state = {
  showUpTip:false,
  logged:false,
  loginBox:null
};

const mutations = {

};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};




// WEBPACK FOOTER //
// ./src/store/header.js